import { AsDisabled } from '~/components/Builder/Common/CreationLimitations/creationLimitations.types';
import i18next from 'i18next';

export const alwaysForbidAddingChargeBlock = ({}) => {
    const t = i18next.getFixedT(null, 'builder', 'creation_limitation_dialog');

    return AsDisabled(t('charge_block_not_allowed_reason'));
};
